import React, { FunctionComponent, useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import {
  API_STATUS_PROBLEM,
  MAIN_COLOR_STRING,
  MAIN_TITLE_FONTSIZE_STRING,
} from '../../../_constant/constants';
import { IApiResult } from '../../../_interface/IApiResult';
import { AlertSeverityEnum } from '../../../_enum/AlertSeverityEnum';
import { IAlertProps } from '../../../_interface/IAlertProps';
import { getDefaultAlertProps, getSimvol } from '../../../utils/utils';
import { MyAlert } from '../../UI/MyAlert';
import { MyTextFiled } from '../../UI/MyTextField';
import { MyPasswordTextField } from '../../UI/MyPasswordTextField';
import { MyButton } from '../../UI/MyButton';
import { WorkerSignUpDto } from '../../../_dto/_worker/WorkerSignUpDto';
import { apiSignUp } from '../../../services/worker/apiSignUp';
import { MyDateTextField } from '../../UI/MyDateTextField';

interface Props {
  open: boolean;
  onClose: () => void;
}

export const DialogWorkerCreate: FunctionComponent<Props> = ({
  open,
  onClose,
}) => {
  const [checkHelper, setCheckHelper] = useState(false);
  const [alertProps, setAlertProps] = useState<IAlertProps>(
    getDefaultAlertProps()
  );

  const [workerSignUpDto, setWorkerSignUpDto] = useState<WorkerSignUpDto>({
    login: '',
    password: '',
    name: '',
    position: '',
    phone: '',
    email: '',
    root: 1,
    birthDate: '',
    employmentDate: '',
    code: '',
  });

  const handleClose = () => {
    onClose();
    setWorkerSignUpDto({
      login: '',
      password: '',
      name: '',
      position: '',
      phone: '',
      email: '',
      root: 1,
      birthDate: '',
      employmentDate: '',
      code: '',
    });
    setCheckHelper(false);
  };

  const signUp = async () => {
    const apiResult: IApiResult = await apiSignUp(workerSignUpDto);
    if (apiResult.isSuccess) {
      handleClose();
    } else if (apiResult.status === 409) {
      setAlertProps({
        message: 'Такой логин существует',
        severity: AlertSeverityEnum.error,
      });
    } else {
      setAlertProps({
        message: API_STATUS_PROBLEM,
        severity: AlertSeverityEnum.error,
      });
    }
  };

  const generateLogin = () => {
    setWorkerSignUpDto({
      ...workerSignUpDto,
      login: getSimvol(8),
      password: getSimvol(8),
    });
  };

  const handleSignUp = async () => {
    if (
      workerSignUpDto.login === '' ||
      workerSignUpDto.name === '' ||
      workerSignUpDto.password === '' ||
      workerSignUpDto.code === ''
    ) {
      setCheckHelper(true);
      return;
    }
    await signUp();
  };

  return (
    <div>
      <MyAlert
        message={alertProps.message}
        severity={alertProps.severity}
        onClose={() => setAlertProps({ ...alertProps, message: '' })}
      />
      <Dialog
        open={open}
        fullWidth
        maxWidth="md"
        style={{ userSelect: 'none' }}
        PaperProps={{ sx: { backgroundColor: '#e7ebee', width: '100%' } }}
      >
        <DialogTitle>
          <Stack direction="row" justifyContent="space-between">
            <Stack direction="row" alignItems="center" spacing={2}>
              <Typography
                style={{
                  fontFamily: 'SF Compact Rounded',
                  fontStyle: 'normal',
                  fontWeight: 600,
                  fontSize: MAIN_TITLE_FONTSIZE_STRING,
                  letterSpacing: 1,
                  color: '#000000',
                }}
                component="text"
              >
                Регистрация
              </Typography>
            </Stack>
            <IconButton size="medium" onClick={() => handleClose()}>
              <CloseIcon fontSize="medium" sx={{ color: MAIN_COLOR_STRING }} />
            </IconButton>
          </Stack>
        </DialogTitle>
        <DialogContent style={{ padding: '20px' }}>
          <Stack spacing={2}>
            <Stack width="100%" direction="row" spacing={1}>
              <MyTextFiled
                value={workerSignUpDto.name}
                onChange={(e) =>
                  setWorkerSignUpDto({
                    ...workerSignUpDto,
                    name: e.target.value,
                  })
                }
                label="Полное имя"
                error={checkHelper}
                size="small"
              />
              <MyTextFiled
                value={workerSignUpDto.position}
                onChange={(e) =>
                  setWorkerSignUpDto({
                    ...workerSignUpDto,
                    position: e.target.value,
                  })
                }
                label="Должность"
                size="small"
              />
            </Stack>
            <Stack width="100%" direction="row" spacing={1}>
              <MyTextFiled
                value={workerSignUpDto.code}
                onChange={(e) =>
                  setWorkerSignUpDto({
                    ...workerSignUpDto,
                    code: e.target.value,
                  })
                }
                label="Шифр"
                error={checkHelper}
                size="small"
              />
              <MyTextFiled
                value={workerSignUpDto.phone}
                onChange={(e) =>
                  setWorkerSignUpDto({
                    ...workerSignUpDto,
                    phone: e.target.value,
                  })
                }
                label="Телефон"
                size="small"
              />
              <MyTextFiled
                value={workerSignUpDto.email}
                onChange={(e) =>
                  setWorkerSignUpDto({
                    ...workerSignUpDto,
                    email: e.target.value,
                  })
                }
                label="E-mail"
                size="small"
              />
            </Stack>
            <Stack width="100%" direction="row" spacing={1}>
              <MyTextFiled
                value={workerSignUpDto.login}
                onChange={(e) =>
                  setWorkerSignUpDto({
                    ...workerSignUpDto,
                    login: e.target.value,
                  })
                }
                label="Логин"
                error={checkHelper}
                size="small"
              />
              <Stack
                width="100%"
                alignItems="center"
                direction="row"
                spacing={1}
              >
                <MyPasswordTextField
                  value={workerSignUpDto.password}
                  onChange={(e) =>
                    setWorkerSignUpDto({
                      ...workerSignUpDto,
                      password: e.target.value,
                    })
                  }
                  label="Пароль"
                  error={checkHelper}
                  size="small"
                />
                <Stack>
                  <IconButton
                    title="Создать логин и пароль"
                    size="small"
                    onClick={() => generateLogin()}
                  >
                    <AutoFixHighIcon
                      fontSize="small"
                      sx={{ color: MAIN_COLOR_STRING }}
                    />
                  </IconButton>
                </Stack>
              </Stack>
            </Stack>
            <Stack width="100%" direction="row" spacing={1}>
              <MyDateTextField
                value={workerSignUpDto.birthDate}
                onChange={(e) =>
                  setWorkerSignUpDto({
                    ...workerSignUpDto,
                    birthDate: e.target.value,
                  })
                }
                label="Дата рождения"
                size="small"
              />
              <MyDateTextField
                value={workerSignUpDto.employmentDate}
                onChange={(e) =>
                  setWorkerSignUpDto({
                    ...workerSignUpDto,
                    employmentDate: e.target.value,
                  })
                }
                label="Дата устройства на работу"
                size="small"
              />
            </Stack>
            <MyButton
              text="Зарегистрировать"
              background={MAIN_COLOR_STRING}
              onClick={handleSignUp}
            />
          </Stack>
        </DialogContent>
      </Dialog>
    </div>
  );
};
